import { Tabs } from "antd";
import React from "react";
import { useSearchParams } from "react-router-dom";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const items = [
  {
    key: "not_edit",
    label: "Đang sửa",
  },
  {
    key: "edit",
    label: "Đã QC",
  },
  {
    key: "merged",
    label: "Bản Xem Cuối",
  },
];

const DetailTabs = () => {
  // -------------------------- VAR -----------------------------
  const [params, setSearchParams] = useSearchParams();
  const tab = params.get("tab") || "not_edit";
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  const handleChangeTab = (key) => {
    setSearchParams({ tab: key });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return <Tabs activeKey={tab} onChange={handleChangeTab} items={items} />;
};
export default DetailTabs;
